import * as React from 'react'
import styles from './index.module.css'

type Props = {
  value: string | number
  valueText: string
}

/**
 * Indicator legend component for displaying a value with descriptive text
 * Simple component that formats and displays statistical values with labels
 * @param value - The numeric or string value to display
 * @param valueText - Descriptive text to display alongside the value
 */
const IndicatorLegend = ({
  value,
  valueText,
}: Props): React.ReactElement<'div'> => (
  <div className={styles.indicatorStats}>
    {value} {valueText}
  </div>
)

export default IndicatorLegend
